module.exports = __webpack_public_path__ + "static/media/credit_get_started.c7dde712.svg";